import * as React from 'react'
import './index.scss'
import './hour.scss'
import Swiper from 'swiper/js/swiper.min.js'
import 'swiper/swiper.scss'
import { HourChampion } from '@pubts/fetch'
import { None, WebAnchorItem, WithPage, WebAnchorItemDesc } from '@huyafed/comp'
const { useEffect } = React;
interface Props {
  data: any;
  iHour: number;
  hourChampion: HourChampion[],
}
const Hour: React.FC<Props> = props => {

  useEffect(() => {
    if (props.hourChampion.length === 0) return;
    let swipers: any = null;
    // tslint:disable-next-line: no-unused-expression
    swipers = new Swiper('.swiper-container', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      initialSlide: props.hourChampion.length - 1,
      slidesPerView: 2,
      observer: true,
    })
    return () => {
      console.log('卸载了')
      swipers = null;
    }
  }, [props.hourChampion])
  return (
    <div className='web-hour'>
      <div className="title br">小时冠军殿堂</div>

      <div className='web-hour-top'>
        {
          props.hourChampion && props.hourChampion.length !== 0 ?
            <>
              <div className="swiper-button-prev"></div>
              <div className="swiper-container">
                {
                  props.hourChampion && props.hourChampion.length !== 0 &&
                  <div className="swiper-wrapper">
                    {
                      props.hourChampion.map((item: any) => (
                        <div key={Math.random()} className='swiper-slide'>
                          <div className='avatar'>
                            <img
                              title={item.tItem.sNickName}
                              src={item.tItem.sLogoUrl}
                              onError={(event: any): void => {
                                event.target.onerror = null;
                                event.target.src = 'https://diy-assets.msstatic.com/Activity-Public-Image/default-1.png';
                              }}
                              onClick={(): void => {
                                window.open('https://m.huya.com/' + item.tItem.tJump.iRoomId, '_blank');
                              }}
                            />
                            <div className='label'>{item.iHour}时冠军</div>
                          </div>
                          <p
                            className='text'
                            onClick={(): void => {
                              window.open('https://m.huya.com/' + item.tItem.tJump.iRoomId, '_blank');
                            }}
                          >
                            <span className="name">{item.tItem.sNickName}</span>
                            <span>小时里程<b>{item.tItem.lScore}</b> ( <i></i>+{item.tItem.iPopularity}w )</span>
                          </p>
                        </div>
                      ))
                    }
                  </div>
                }
              </div>
              <div className="swiper-button-next"></div>
            </>
            : <None text='暂无小时冠军数据' color={'#fff'} />
        }


      </div>

      <div className='web-hour-bottom'>
        <div className="title bt">{props.iHour}时小时榜</div>
        <WebAnchorItemDesc
          width={960}
          color="#59c6ff"
          descs={['排名', '主播昵称', '小时里程（预计可得）']}
        />
        <ul className='web-hour-list'>
          {
            props.data.length === 0 ?
              <None text={'暂无小时榜数据'} color={'#fff'} />
              :
              props.data.map((items: any, idx: number) => (
                <li key={idx} className={`team-list`}>
                  <div className='rankNoCover'>
                    <div className={`rank-${items.iRank <= 3 ? items.iRank : 'n'}`}>
                      {items.iRank}
                    </div>
                  </div>
                  <div className='tPersenter'>
                    <><img
                      title={items.sNickName}
                      src={items.sLogoUrl}
                      onError={(event: any): void => {
                        event.target.onerror = null;
                        event.target.src = 'https://diy-assets.msstatic.com/Activity-Public-Image/default-2.png';
                      }} />{items.sNickName}</>
                  </div>
                  <div className='score'>
                    <h1>
                      {items.lScore}
                      <span className="rq">{items.iPopularity}w</span>
                    </h1>
                  </div>
                </li>
              ))
          }
        </ul>
        {props.children}
      </div>
    </div>
  )
}
export default WithPage(Hour);